/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabels } from '@/wpt-lib/pdf/useData';
import { label } from '@/wpt-lib/utils/label';

const ServiceBenchmarks = ({
    serviceExpectationsAreas = {},
    serviceExpectationsLevel = {},
}: Partial<{
    serviceExpectationsAreas: { [area: string]: boolean };
    serviceExpectationsLevel: { [area: string]: string };
}>) => {
    const areas = useLabels('serviceExpectationsAreas');

    return (
        <>
            {Object.entries(serviceExpectationsAreas)
                .filter(([, a]) => a)
                .map(([area]) => (
                    <Row key={area} widths={[80, 20]}>
                        <ValueCell label="Aligned Benchmark" value={label(areas, area)} />
                        <ValueCell label="Academic Level" value={serviceExpectationsLevel[area]} />
                    </Row>
                ))}
        </>
    );
};

export default ServiceBenchmarks;
